import { Plug, Webhook } from 'lucide-react'

import { assistantEffects } from '@/lib/assistant-effects.generated'
import { defineModule } from '@/lib/module-routes'
import { INTEGRATION_PERMISSIONS } from '@/lib/permissions'

import { httpConnectionsApi } from './api/http-connections-api'
import { integrationsKeys } from './api/query-keys'
import { API_CONNECTIONS_DESCRIPTION } from './integration'
import { apiConnectionsRoute, integrationsRoute } from './routes'

export const integrationsModule = defineModule({
  routes: [integrationsRoute, apiConnectionsRoute],
  navigation: {
    admin: [
      {
        to: '/$entityId/settings/integrations',
        label: 'Integrations',
        icon: Plug,
        permission: INTEGRATION_PERMISSIONS.read,
        section: 'settings',
        order: 50,
      },
    ],
  },
  integrationCards: [
    {
      id: 'api-connections',
      name: 'API connections',
      description: API_CONNECTIONS_DESCRIPTION,
      icon: Webhook,
      order: 20,
      to: '/$entityId/settings/integrations/api-connections',
      readPermission: INTEGRATION_PERMISSIONS.read,
      managePermission: INTEGRATION_PERMISSIONS.manage,
      connectionCount: (entityId) => ({
        queryKey: [...integrationsKeys.httpConnections(entityId), 'count'],
        queryFn: async ({ signal }) =>
          (await httpConnectionsApi.listConnections(entityId, signal)).length,
        meta: { assistantEffects: [assistantEffects.httpConnectionsChanged] },
      }),
    },
  ],
})
